<ion-header>
  <ion-toolbar class="sticky-toolbar">
    <div class="toolbar-container">
      <div class="flexed header-container">
        <ion-buttons slot="start">
          <ion-button (click)="navigateBack()">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <app-article-location-display
          [collectionId]="collectionId"
          (moveRequested)="showCollectionSelector($event)"
          [disabled]="isGeneratingArticle || isLoading"
        ></app-article-location-display>
      </div>
      <ion-buttons slot="end">
        <ion-button
          [hidden]="!articleId"
          (click)="showArticleActions($event)"
          [disabled]="isLoading || isGeneratingArticle"
          class="nav-button"
          color="dark"
          fill="clear"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            content: 'Show article options'
          }"
        >
          <ion-icon name="ellipsis-horizontal"></ion-icon>
        </ion-button>
        <ion-button
          (click)="saveArticle()"
          [disabled]="isLoading || !title"
          class="button-dark-border"
          style="margin: 0 8px"
        >
          <ion-spinner *ngIf="isLoading" name="crescent" style="margin-right: 10px"></ion-spinner>
          Save
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content [ngClass]="{ 'linear-gradient-subtle-animated': isGeneratingArticle }">
  <ion-grid fixed="true">
    <ion-row>
      <!-- Main Content Column -->
      <ion-col size="12" size-md="8">
        <ion-input
          #titleInput
          placeholder="e.g. How to configure SSO"
          [(ngModel)]="title"
          class="input-field title-input"
          (keydown)="handleTitleKeydown($event)"
          [disabled]="isGeneratingArticle || isLoading"
        ></ion-input>

        <div class="tiptap-editor-container" [ngClass]="{ 'linear-gradient-subtle-animated': isGeneratingArticle }">
          <app-knowledge-base-editor
            #editorContainer
            [initialContent]=""
            (focusTitle)="onFocusTitleRequested()"
            [editable]="!isLoading && !isGeneratingArticle"
          ></app-knowledge-base-editor>
        </div>
      </ion-col>

      <!-- Right Sidebar Column -->
      <ion-col size="12" size-md="4">
        <ion-card class="sidebar-card">
          <ion-card-content>
            <!-- Status -->
            <ion-label class="input-label">Status</ion-label>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="status"
              style="width: 100%; padding: 10px; margin-bottom: 10px"
              placeholder="Select Status"
              [disabled]="isGeneratingArticle || isLoading"
            >
              <ion-select-option value="active">Active</ion-select-option>
              <ion-select-option value="inactive">Inactive</ion-select-option>
            </ion-select>

            <!-- Link -->
            <ion-label class="input-label">Source Link</ion-label>
            <ion-input
              placeholder="https://example.com (Optional)"
              [(ngModel)]="url"
              class="input-field link-input"
              type="url"
              [disabled]="isGeneratingArticle || isLoading"
            ></ion-input>

            <!-- Visibility Section -->
            <ion-label class="input-label">Visibility</ion-label>
            <div class="user-groups-container">
              <ion-chip
                *ngIf="!userGroups?.length"
                color="success"
                class="chip"
                style="height: 20px; padding: 6px"
                mode="ios"
              >
                <ion-label>Public</ion-label>
              </ion-chip>
              <ion-chip
                *ngFor="let group of userGroups; trackBy: trackByUserGroupId"
                mode="ios"
                color="dark"
                class="chip tag-chip"
                style="margin: 0 7px"
              >
                <ion-label (click)="!isLoading && !isGeneratingArticle && removeUserGroup(group.id!)">{{
                  group.name
                }}</ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="dark"
                class="chip tag-chip tag-chip-light"
                (click)="addUserGroup($event)"
                style="background: transparent"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Restrict document access to certain user groups'
                }"
              >
                <ion-label>
                  <ion-icon name="lock-closed-outline"></ion-icon
                  ><ion-icon name="add-outline" style="margin-left: -3px"></ion-icon>
                </ion-label>
              </ion-chip>
            </div>
            <ion-label class="input-label">Channels</ion-label>
            <div class="user-groups-container">
              <ion-chip
                *ngIf="!channels?.length"
                color="success"
                class="chip"
                style="height: 20px; padding: 6px"
                mode="ios"
              >
                <ion-label>All channels</ion-label>
              </ion-chip>
              <ion-chip
                *ngFor="let channel of channels; trackBy: trackByChannelId"
                mode="ios"
                color="dark"
                class="chip tag-chip"
                style="margin: 0 7px"
              >
                <ion-label (click)="!isLoading && !isGeneratingArticle && removeChannel(channel.id)">
                  {{ channel.name }}
                </ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="dark"
                class="chip tag-chip tag-chip-light"
                (click)="addChannel($event)"
                style="background: transparent"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Restrict document access to certain channels'
                }"
              >
                <ion-label>
                  <ion-icon name="chatbubble-outline"></ion-icon
                  ><ion-icon name="add-outline" style="margin-left: -3px"></ion-icon>
                </ion-label>
              </ion-chip>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
